import { resolveUserStepPath } from './portalV2';

/**
 * Maps backend userStepId → app route.
 * When Portal V2 is enabled (Config.js usePortalV2), returns *-v2 paths;
 * otherwise classic paths (unchanged default).
 */
const currentUserStep = (userStep) => resolveUserStepPath(userStep);

export default currentUserStep;
